import { FC } from 'react'

export const EnpalHeaderLogo: FC = () => (
  <svg
    aria-hidden="true"
    width="119"
    height="36"
    viewBox="0 0 119 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_151_2737)">
      <path
        d="M0 1.66638H18.4712V6.47821H6.26256V11.7189H17.0332V16.612H6.25804V21.8526H18.4666V26.6644H0V1.66638Z"
        fill="#072543"
      />
      <path
        d="M21.6574 8.26625H27.4904L27.6849 9.85966C28.4897 9.2909 29.4664 8.81695 30.6194 8.44229C31.7724 8.06764 32.9572 7.87805 34.178 7.87805C36.5383 7.87805 38.2656 8.4468 39.3689 9.58431C40.4722 10.7218 41.0193 12.4822 41.0193 14.8655V26.6649H34.7567V15.3711C34.7567 14.3374 34.5307 13.5972 34.074 13.1593C33.6219 12.7215 32.835 12.5003 31.7227 12.5003C31.049 12.5003 30.3616 12.6537 29.6608 12.9652C28.96 13.2767 28.3766 13.6648 27.9109 14.1299V26.6695H21.6483V8.26625H21.6574Z"
        fill="#072543"
      />
      <path
        d="M44.9942 8.26625H50.4383L50.7502 9.85965C52.3555 8.54159 54.2907 7.87805 56.5426 7.87805C62.2218 7.87805 65.0569 10.943 65.0569 17.0774C65.0569 20.3364 64.2791 22.8146 62.7237 24.5118C61.1682 26.209 59.0024 27.0531 56.2305 27.0531C54.2862 27.0531 52.6267 26.6514 51.2522 25.848V35.0473H44.9896V8.26625H44.9942ZM57.6504 21.0768C58.3377 20.1468 58.6814 18.7746 58.6814 16.96C58.6814 15.2537 58.3784 14.0756 57.7679 13.4257C57.1575 12.7801 56.1537 12.4551 54.752 12.4551C53.4316 12.4551 52.265 12.9201 51.2522 13.8544V21.3069C51.7721 21.6951 52.2831 21.9841 52.7896 22.1827C53.296 22.3767 53.9109 22.4715 54.6344 22.4715C55.9592 22.476 56.9631 22.0066 57.6504 21.0768Z"
        fill="#072543"
      />
      <path
        d="M69.5081 25.5578C68.2782 24.5602 67.6633 23.1293 67.6633 21.2696C67.6633 19.3557 68.3189 17.8661 69.6257 16.8054C70.9325 15.7446 72.8451 15.2119 75.3637 15.2119H80.4959V14.7876C80.4959 13.8307 80.1793 13.1581 79.5417 12.7699C78.9042 12.3817 77.7466 12.1876 76.06 12.1876C73.962 12.1876 71.9 12.5126 69.8789 13.1581V9.12267C70.8103 8.76156 71.9407 8.46364 73.2611 8.22892C74.5815 7.99419 75.9425 7.88135 77.3442 7.88135C80.2743 7.88135 82.5306 8.47717 84.1086 9.66886C85.6912 10.8605 86.4825 12.6976 86.4825 15.1803V26.6728H80.9977L80.6858 25.1199C79.2614 26.4155 77.0955 27.061 74.1926 27.061C72.298 27.0519 70.738 26.5554 69.5081 25.5578ZM80.4913 21.4231V18.823H76.06C75.1286 18.823 74.4323 19.0036 73.9801 19.3648C73.5279 19.7258 73.3018 20.2856 73.3018 21.0348C73.3018 22.4838 74.2604 23.2106 76.1776 23.2106C78.0406 23.2106 79.483 22.6147 80.4913 21.4231Z"
        fill="#072543"
      />
      <path
        d="M91.8988 25.7328C91.017 24.8525 90.5784 23.4443 90.5784 21.5032V0.5H96.8409V20.8803C96.8409 21.4762 96.9585 21.8824 97.1891 22.1036C97.4241 22.3247 97.8 22.4331 98.3152 22.4331C99.0154 22.4331 99.6358 22.3428 100.182 22.1623V26.3918C99.5589 26.6265 98.957 26.7936 98.3736 26.8974C97.7903 27.0012 97.0852 27.0508 96.2532 27.0508C94.2319 27.0508 92.7759 26.613 91.8988 25.7328Z"
        fill="#072543"
      />
      <path
        d="M114.087 27.8082C116.699 27.8082 118.816 25.6943 118.816 23.0866C118.816 20.479 116.699 18.3651 114.087 18.3651C111.474 18.3651 109.356 20.479 109.356 23.0866C109.356 25.6943 111.474 27.8082 114.087 27.8082Z"
        fill="#FFC700"
      />
    </g>
    <defs>
      <clipPath id="clip0_151_2737">
        <rect width="118.816" height="35" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
)

export const EnpalHeaderLogoMobile: FC = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="89"
    height="27"
    viewBox="0 0 89 27"
    fill="none"
  >
    <g clipPath="url(#clip0_1072_1222)">
      <path
        d="M0 1.0603H13.836V4.6348H4.69102V8.52786H12.7589V12.1627H4.68764V16.0558H13.8326V19.6303H0V1.0603Z"
        fill="#072543"
      />
      <path
        d="M16.2236 5.96318H20.5928L20.7385 7.14685C21.3414 6.72435 22.073 6.37227 22.9367 6.09395C23.8003 5.81564 24.6878 5.6748 25.6022 5.6748C27.3702 5.6748 28.6641 6.0973 29.4906 6.94231C30.3169 7.78733 30.7268 9.09505 30.7268 10.8655V19.6308H26.0358V11.2411C26.0358 10.4732 25.8664 9.9233 25.5244 9.59801C25.1857 9.27279 24.5963 9.10849 23.763 9.10849C23.2584 9.10849 22.7436 9.22245 22.2186 9.45385C21.6937 9.68525 21.2567 9.97357 20.9078 10.319V19.6342H16.2168V5.96318H16.2236Z"
        fill="#072543"
      />
      <path
        d="M33.7026 5.96318H37.7806L38.0143 7.14685C39.2167 6.16772 40.6663 5.6748 42.3531 5.6748C46.6071 5.6748 48.7308 7.95163 48.7308 12.5086C48.7308 14.9296 48.1482 16.7705 46.9831 18.0313C45.818 19.2921 44.1956 19.9191 42.1193 19.9191C40.663 19.9191 39.4199 19.6207 38.3902 19.0239V25.8577H33.6992V5.96318H33.7026ZM43.1829 15.4796C43.6977 14.7888 43.9552 13.7694 43.9552 12.4214C43.9552 11.1539 43.7282 10.2787 43.271 9.7959C42.8137 9.31634 42.0618 9.0749 41.0118 9.0749C40.0228 9.0749 39.1489 9.42034 38.3902 10.1144V15.6505C38.7797 15.9389 39.1625 16.1535 39.5418 16.3011C39.9212 16.4453 40.3818 16.5157 40.9238 16.5157C41.9161 16.519 42.6681 16.1703 43.1829 15.4796Z"
        fill="#072543"
      />
      <path
        d="M52.0655 18.8083C51.1442 18.0673 50.6836 17.0043 50.6836 15.6228C50.6836 14.2011 51.1747 13.0945 52.1536 12.3065C53.1324 11.5185 54.5651 11.1228 56.4517 11.1228H60.296V10.8076C60.296 10.0967 60.0589 9.59711 59.5813 9.30873C59.1037 9.02035 58.2366 8.87619 56.9733 8.87619C55.4017 8.87619 53.8572 9.11763 52.3432 9.59711V6.59937C53.0409 6.33112 53.8877 6.10981 54.8767 5.93544C55.8657 5.76107 56.8852 5.67725 57.9352 5.67725C60.13 5.67725 61.8201 6.11986 63.0021 7.00511C64.1876 7.89036 64.7803 9.25507 64.7803 11.0993V19.6366H60.6719L60.4382 18.483C59.3713 19.4455 57.7489 19.925 55.5744 19.925C54.1553 19.9182 52.9867 19.5494 52.0655 18.8083ZM60.2925 15.7368V13.8054H56.9733C56.2756 13.8054 55.754 13.9395 55.4153 14.2078C55.0765 14.476 54.9072 14.8918 54.9072 15.4484C54.9072 16.5248 55.6252 17.0647 57.0613 17.0647C58.4568 17.0647 59.5373 16.622 60.2925 15.7368Z"
        fill="#072543"
      />
      <path
        d="M68.8367 18.9382C68.1762 18.2843 67.8477 17.2381 67.8477 15.7962V0.193848H72.5386V15.3335C72.5386 15.7762 72.6267 16.0779 72.7994 16.2422C72.9754 16.4065 73.257 16.487 73.6429 16.487C74.1675 16.487 74.6322 16.4199 75.0414 16.2858V19.4278C74.5745 19.6021 74.1237 19.7262 73.6867 19.8033C73.2497 19.8805 72.7216 19.9173 72.0984 19.9173C70.5843 19.9173 69.4937 19.5921 68.8367 18.9382Z"
        fill="#072543"
      />
      <path
        d="M85.4573 20.48C87.4138 20.48 88.9998 18.9096 88.9998 16.9725C88.9998 15.0354 87.4138 13.4651 85.4573 13.4651C83.5 13.4651 81.9141 15.0354 81.9141 16.9725C81.9141 18.9096 83.5 20.48 85.4573 20.48Z"
        fill="#FFC700"
      />
    </g>
    <defs>
      <clipPath id="clip0_1072_1222">
        <rect width="89" height="26" fill="white" transform="translate(0 0.193848)" />
      </clipPath>
    </defs>
  </svg>
)
